import {
    TOTAIS_DASHBOARD_PENDING,
    TOTAIS_DASHBOARD_SUCCESS,
    TOTAIS_DASHBOARD_FAILURE,
    GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_PENDING,
    GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_SUCCESS,
    GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_FAILURE,
    GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_PENDING,
    GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_SUCCESS,
    GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_FAILURE,
    CUSTO_LIST_PROCEDIMENTOS_PENDING,
    CUSTO_LIST_PROCEDIMENTOS_SUCCESS,
    CUSTO_LIST_PROCEDIMENTOS_FAILURE,
    CUSTO_LIST_DESPESAS_DIRETAS_PENDING,
    CUSTO_LIST_DESPESAS_DIRETAS_SUCCESS,
    CUSTO_LIST_DESPESAS_DIRETAS_FAILURE,
    CUSTO_LIST_INSUMOS_PENDING,
    CUSTO_LIST_INSUMOS_SUCCESS,
    CUSTO_LIST_INSUMOS_FAILURE,
    CUSTO_LIST_MAQUINARIOS_PENDING,
    CUSTO_LIST_MAQUINARIOS_SUCCESS,
    CUSTO_LIST_MAQUINARIOS_FAILURE,
    CUSTO_LIST_FUNCIONARIOS_PENDING,
    CUSTO_LIST_FUNCIONARIOS_SUCCESS,
    CUSTO_LIST_FUNCIONARIOS_FAILURE,
} from './actionTypes';

const totaisInit = {
    totalColheita: 0,
    totalSafra: 0,
    totalSafraHa: 0,
    totalInsumos: 0,
    totalFuncionarios: 0,
    totalMaquinarios: 0,
    totalRateioDespDireta: 0
}

const initialState = {
    totais: totaisInit,
    dadosGraficoCustoProducaoPorTalhao: null,
    dadosListCustosProcedimentos: null,
    dadosListCustosDespesasDireta: null,
    dadosListCustosInsumos: null,
    dadosListCustosMaquinarios: null,
    dadosListCustosFuncionarios: null,

    loading: false,
    loadingDadosGraficoCustoProducaoPorTalhao: false,
    loadingCustosProcedimentos: false,
    loadingCustosDespesasDiretas: false,
    loadingCustosInsumos: false,
    loadingCustosMaquinarios: false,
    loadingCustosFuncionarios: false,
}


function dashboardReducer(state = initialState, action) {

    switch (action.type) {
        case TOTAIS_DASHBOARD_PENDING:
            return {
                ...state,
                loading: true,
            }
        case TOTAIS_DASHBOARD_SUCCESS:
            return {
                ...state,
                totais: action.totais,
                loading: false
            }
        case TOTAIS_DASHBOARD_FAILURE:
            return {
                ...state,
                totais: totaisInit,
                loading: false
            }
        

        case GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_PENDING:
             return {
                ...state,
                loadingDadosGraficoCustoProducaoPorTalhao: true,
            }
        case GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_SUCCESS:
            return {
                ...state,
                dadosGraficoCustoProducaoPorTalhao: action.dadosGraficoCustoProducaoPorTalhao,
                loadingDadosGraficoCustoProducaoPorTalhao: false
            }
        case GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD_FAILURE:
            return {
                ...state,
                dadosGraficoCustoProducaoPorTalhao: [['', 'Custo']],
                loadingDadosGraficoCustoProducaoPorTalhao: false
            }


        case GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_PENDING:
             return {
                ...state,
                loadingDadosGraficoCustoTipoInsumo: true,
            }
        case GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_SUCCESS:
            return {
                ...state,
                dadosGraficoCustoTipoInsumo: action.dadosGraficoCustoTipoInsumo,
                loadingDadosGraficoCustoTipoInsumo: false,
            }
        case GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD_FAILURE:
            return {
                ...state,
                dadosGraficoCustoTipoInsumo: [['Grupo', 'Total']],
                loadingDadosGraficoCustoTipoInsumo: false,
            }
        

        case CUSTO_LIST_PROCEDIMENTOS_PENDING:
            return {
                ...state,
                loadingCustosProcedimentos: true
            };
        case CUSTO_LIST_PROCEDIMENTOS_SUCCESS:
            return {
                ...state,
                loadingCustosProcedimentos: false,
                dadosListCustosProcedimentos: action.dadosListCustosProcedimentos
            };
        case CUSTO_LIST_PROCEDIMENTOS_FAILURE:
            return {
                ...state,
                loadingCustosProcedimentos: false,
                dadosListCustosProcedimentos: [],
            };

            
        case CUSTO_LIST_DESPESAS_DIRETAS_PENDING:
            return {
                ...state,
                loadingCustosDespesasDiretas: true
            };
        case CUSTO_LIST_DESPESAS_DIRETAS_SUCCESS:
            return {
                ...state,
                loadingCustosDespesasDiretas: false,
                dadosListCustosDespesasDireta: action.dadosListCustosDespesasDireta
            };
        case CUSTO_LIST_DESPESAS_DIRETAS_FAILURE:
            return {
                ...state,
                loadingCustosDespesasDiretas: false,
                dadosListCustosDespesasDireta: [],
            };


        case CUSTO_LIST_INSUMOS_PENDING:
            return {
                ...state,
                loadingCustosInsumos: true
            };
        case CUSTO_LIST_INSUMOS_SUCCESS:
            return {
                ...state,
                loadingCustosInsumos: false,
                dadosListCustosInsumos: action.dadosListCustosInsumos
            };
        case CUSTO_LIST_INSUMOS_FAILURE:
            return {
                ...state,
                loadingCustosInsumos: false,
                dadosListCustosInsumos: [],
            };


        case CUSTO_LIST_MAQUINARIOS_PENDING:
            return {
                ...state,
                loadingCustosMaquinarios: true
            };
        case CUSTO_LIST_MAQUINARIOS_SUCCESS:
            return {
                ...state,
                loadingCustosMaquinarios: false,
                dadosListCustosMaquinarios: action.dadosListCustosMaquinarios
            };
        case CUSTO_LIST_MAQUINARIOS_FAILURE:
            return {
                ...state,
                loadingCustosMaquinarios: false,
                dadosListCustosMaquinarios: [],
            };


        case CUSTO_LIST_FUNCIONARIOS_PENDING:
            return {
                ...state,
                loadingCustosFuncionarios: true
            };
        case CUSTO_LIST_FUNCIONARIOS_SUCCESS:
            return {
                ...state,
                loadingCustosFuncionarios: false,
                dadosListCustosFuncionarios: action.dadosListCustosFuncionarios
            };
        case CUSTO_LIST_FUNCIONARIOS_FAILURE:
            return {
                ...state,
                loadingCustosFuncionarios: false,
                dadosListCustosFuncionarios: [],
            };
        default:
            return state
    }
}

export { dashboardReducer };
